<template>
  <svg
    width="26"
    height="26"
    viewBox="0 0 20 24"
    fill="none"
    :class="{ customColor: !!customColor }"
    :style="customColor && { '--bin-color': customColor }"
  >
    <path
      d="M1.6521 4.6084L18.1739 4.69536"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3913 4.60871H6.43475V4.00001C6.43475 2.86957 7.30432 2 8.43477 2H11.3913C12.5217 2 13.3913 2.86957 13.3913 4.00001V4.60871Z"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.91313 8.08691L9.82617 18.5218"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.43461 8.08691L6.34766 18.5218"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3912 8.08691L13.3043 18.5218"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.391 21.9998L6.17353 21.9128C4.78221 21.9128 3.65177 20.7824 3.56482 19.3911L2.95612 4.6084L16.8692 4.69536L15.9997 19.565C15.9127 20.9563 14.7823 21.9998 13.391 21.9998Z"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
const VARIANT_COLORS = {
  red: '#E47474',
}

export default {
  props: {
    variant: {
      required: false,
    },
  },

  data() {
    return {
      customColor: null,
    }
  },

  created() {
    const customColor = VARIANT_COLORS[this.variant || '']

    if (customColor) this.customColor = customColor
  },
}
</script>

<style scoped lang="scss">
svg {
  path {
    stroke: $white;

    .light & {
      stroke: $gray-6;
    }
  }

  &.customColor {
    path {
      stroke: var(--bin-color);
    }
  }
}
</style>
